import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { TranslationKeys } from './TranslationKeys';
export var getTranslationKeys = function getTranslationKeys() {
  return Object.values(TranslationKeys);
};
export var getTranslationsWithFallback = function getTranslationsWithFallback(translations) {
  if (translations) {
    return translations;
  }
  return getTranslationKeys().map(function (key) {
    return _defineProperty({}, key, key);
  }).reduce(function (prev, next) {
    return _objectSpread(_objectSpread({}, prev), next);
  });
};